/**
 * In-memory CSRF token store.
 *
 * The token-exchange response includes the CSRF token in its JSON body
 * because third-party iframe contexts (Outlook WebView2, partitioned cookie
 * storage) often prevent `document.cookie` from reading the non-HttpOnly
 * `csrf_token` cookie set by the backend.
 *
 * This module provides a simple getter/setter so:
 *   - authService stores the token after a successful token-exchange
 *   - apiClient reads it as a fallback when the cookie is unreadable
 */
let _csrfToken = null;
/** Store the CSRF token received from the token-exchange response body. */
export function setCsrfToken(token) {
    _csrfToken = token;
}
/** Retrieve the in-memory CSRF token. Returns null if not yet set. */
export function getCsrfToken() {
    return _csrfToken;
}
/** Clear the stored CSRF token (e.g. on logout). */
export function clearCsrfToken() {
    _csrfToken = null;
}
